// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__390hZ","select":"Header_select__nJkPb","clinic":"Header_clinic__3PDom"};